import { useTranslation } from "react-i18next";
export var labelizeUnderScoreText = function (rawText) {
    if (!rawText)
        return '';
    var exceptions = {
        VIP: 'VIP',
        CEO: 'CEO',
        AI: 'AI',
    };
    var upperRaw = rawText.toUpperCase();
    if (exceptions[upperRaw]) {
        return exceptions[upperRaw];
    }
    var isMachineLabel = rawText.includes('_')
        || rawText === upperRaw
        || (!/\s/.test(rawText) && rawText === rawText.toLowerCase());
    // Localized and user-entered text already owns its casing and must be returned unchanged.
    if (!isMachineLabel)
        return rawText;
    return rawText
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(^|[\s/-])\S/g, function (segment) { return segment.toUpperCase(); });
};
export var ellpisize = function (text, maxLength) {
    if (!text)
        return undefined;
    if (!maxLength)
        return text;
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
};
export var useLocalize = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var localize = function (text) {
        if (!text)
            return undefined;
        return text[i18n.language] || text['en'] || Object.values(text)[0];
    };
    var tFallback = function (key, fallback, options) {
        // Check if the key exists in the current language and if not, fallback
        if (i18n.exists(key)) {
            return t(key, options);
        }
        else {
            return fallback;
        }
    };
    return {
        t: t,
        i18n: i18n,
        language: i18n.language,
        localize: localize,
        tFallback: tFallback
    };
};
export var useTranslateForLanguage = function () {
    var i18n = useTranslation().i18n;
    var tFor = function (lang) { return i18n.getFixedT(lang); };
    return { tFor: tFor };
};
